/**
 * Created by wwei on 2018-12-19.
 */

import React, { Component } from 'react';
import request from 'superagent';
import { Button, Form, Checkbox } from 'antd';
import { openNotification, NotificationType, permissionCheck } from "../../commons/CommonUtils.js";
import { Permissions } from "../../commons/Constants.js";
import Loading from '../../commons/Loading.js';
const FormItem = Form.Item;
const CheckboxGroup = Checkbox.Group;

const EXCLUDE_FEATURES = ['landingPage', 'showLicensing', 'showAdministrationApp', 'showAqua'];
const FEATURE_LABELS = {
    "showPDMSSPApp": "PDMS-SP",
    "showPDMSEApp": "PDMS-E",
    "showTempPdms": "PDMS-E Dev",
    "showPlantronicsApp": "Plantronics Manager",
    "showRealConnectApp": "RealConnect",
    "showOneTouchDialApp": "OTD",
    "showA4BApp": "A4B",
    "showDA": "Device Analytics",
    "showAquaAnalyticsApp": "RealConnect Report",
    "showRealAccessApp": "RealAccess",
    "showCloudDevicesApp": "Register Devices",
    "showAdministrationApp": "Administration",
    "showSupportApp": "Support",

    "showDomainMgmt": "Domain Management",
    "showLicensing": "Licensing",
    "showApiDocsLink": "API Docs",
    "showDocumentConfig": "Document Services",
    "showPdmsBeta": "Beta Tag",
    "showTenantOfTenants": "Sub-Accounts"
}

class TenantFeatureControlForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            saving: false,
            enabledFeatures: [],
            allFeatures: [],
            tid: null
        };
    }

    componentDidMount() {
        const tid = this.props.tenantId;
        this.setState({tid});
        this.initFeatures(tid);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.tenantId && this.state.tid !== nextProps.tenantId) {
            this.reset();
            this.setState({tid: nextProps.tenantId});
            this.initFeatures(nextProps.tenantId);
        }
    }

    reset = () => {
        this.props.form.resetFields();
    }

    initFeatures = tid => {
        this.setState({loading: true});
        request.get('/api/tenant-manager/' + tid + '/features')
            .withCredentials()
            .end((err, res) => {
                if (!err) {
                    const featureObj = res.body;

                    let allFeatures = [];
                    let enabledFeatures = [];

                    const keys = Object.keys(featureObj);
                    keys.forEach(key => {
                        if (typeof featureObj[key] === 'boolean' && EXCLUDE_FEATURES.indexOf(key) === -1) {
                            allFeatures.push({ 'value': key, 'label': FEATURE_LABELS[key] ? FEATURE_LABELS[key] : key});
                            if (featureObj[key]) {
                                enabledFeatures.push(key);
                            }
                        }
                    });
                    allFeatures = allFeatures.sort((o1, o2) => {
                        return o1.label.toLowerCase() > o2.label.toLowerCase() ? 1 : -1;
                    });
                    this.setState({allFeatures, enabledFeatures});
                }
                this.setState({loading: false});
            });
    }

    saveFeatures = () => {
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.setState({saving: true});
                const allFeatures = this.state.allFeatures;
                let obj = {};
                allFeatures.forEach(feature => {
                    obj[feature.value] = values.features.indexOf(feature.value) !== -1;
                });
                request.post('/api/tenant-manager/' + this.state.tid + '/features')
                    .send(obj)
                    .withCredentials()
                    .end((err, res) => {
                        if (err) {
                            console.log(err);
                            openNotification("Failed to update feature flags.", NotificationType.error);
                        } else {
                            openNotification("Succeed to update feature flags.", NotificationType.success);
                        }
                        this.setState({saving: false});
                    });
            }
        });
    }

    render() {
        const { loading, saving, enabledFeatures, allFeatures } = this.state;
        const { getFieldDecorator } = this.props.form;
        const formItemLayout = {
            labelCol: { xs: {span: 24}, sm: {span: 5} },
            wrapperCol: { xs: {span: 24}, sm: {span: 19} }
        };
        const isDisabled = !permissionCheck([Permissions.TenantManager.UPDATE]);

        return (
            <div className="tenant-user-form">
                {loading ? <Loading /> : (
                    <Form>
                        <FormItem {...formItemLayout} label="Features">
                            {getFieldDecorator("features", {
                                initialValue: enabledFeatures,
                                rules: [
                                    {type: "array"},
                                    {required: !isDisabled, message: "This field is required"}
                                ]
                            })(<CheckboxGroup options={allFeatures} disabled={isDisabled}/>)}
                        </FormItem>

                        { !isDisabled && (
                            <div className="ant-modal-footer" style={{ paddingLeft: 0 }} >
                                <div className="col-lg-8" style={{ textAlign: "left", padding: 0 }} >
                                    <Button key="submit" type="primary"
                                            size="large" loading={saving}
                                            onClick={this.saveFeatures} >
                                        Save
                                    </Button>
                                    <Button key="cancel" size="large"
                                            onClick={this.reset} disabled={saving} >
                                        Reset
                                    </Button>
                                </div>
                            </div>
                        )}
                    </Form>
                )}
            </div>
        );
    }

}

const TenantFeatureControl = Form.create()(TenantFeatureControlForm);
export default TenantFeatureControl;


// WEBPACK FOOTER //
// ./src/modules/tenants/TenantFeatureControl.js